import Vue from 'vue'
import axios from 'axios'

import * as types from '../mutation-types'

import {
  uniqWith,
  getObjectValue,
  createTheParametersOfTheUrl,
} from '../../plugins/helper'

const { connect } = require('../../plugins/notificationHelper')

const defaultPagination = {
  count: 0,
  current_page: 1,
  links: {},
  per_page: 0,
  total: 0,
  total_pages: 0,
}

// state
export const state = {
  loading: false,
  rooms: [],
  roomActive: null,
  error: null,
  roomStore: null,
  roomStoreError: null,
  loadingRoomsMessages: false,
  roomsMessages: [],
  roomsMessagesIds: new Set(),
  roomsMessagesPagination: defaultPagination,
  errorRoomsMessages: null,
  roomMessageActive: null,
  loadingRoomCustomerActive: true,
  roomCustomerActive: null,
  errorRoomCustomerActive: null,
  loadingNotifyRoomChange: false,
  notifyRoomChange: null,
  errorNotifyRoomChange: null,
  loadingRegisterSubscriptionConversation: false,
  registerSubscriptionConversation: null,
  errorRegisterSubscriptionConversation: null,
  loadingRoom: false,
  room: [],
  errorRoom: null,
  loadingRoomHistory: false,
  roomHistory: null,
  errorRoomHistory: null,
}

const setLintenerRoomCreated = (Echo) => {
  Echo.channel('presence-event-pusher-conversation.creation')
    .listen('.conversation.creation', function (event) {
      if (state.roomsMessagesIds && !state.roomsMessagesIds.has(event.sid)) {
        state.roomsMessagesIds.add(event.conversation.data.roomId)
        state.roomsMessages.unshift(event.conversation.data)
      } else {
        const room = state.roomsMessages.find((room) => room.roomId === event.sid)
        if (room) {
          Vue.set(room, 'lastMessage', event.conversation.data.lastMessage)
          Vue.set(room, 'state', event.conversation.data.state)
          Vue.set(room, 'action_conversation_date', event.conversation.data.action_conversation_date)
          Vue.set(room, 'creation_date', event.conversation.data.creation_date)
          const {users} = room
          if (users) {
            const status = ['active', 'inactive'].indexOf(event.conversation.data.state) !== -1 ? 'online' : 'offline'
            users.forEach((user) => {
              if (user.status && user.status.state) {
                user.status.state = status
              }
            })
            Vue.set(room, 'users', users)
          }
        }
      }
    })
}

// mutations
export const mutations = {
  [types.GET_ROOMS_START](state) {
    state.loading = true
    state.rooms = []
    state.roomActive = null
    state.error = null
  },

  [types.GET_ROOMS_SUCCESS](state, { data }) {
    state.loading = false
    state.rooms = data.data
    state.roomActive = (data.active || null)
    state.error = null
  },

  [types.GET_ROOMS_ERROR](state, { error }) {
    state.loading = false
    state.rooms = []
    state.roomActive = null
    state.error = error
  },

  [types.STORE_ROOM_START](state) {
    state.roomStore = null
    state.roomStoreError = null
  },
  [types.STORE_ROOM_SUCCESS](state, { data }) {
    state.roomStore = data
    state.roomStoreError = null
  },
  [types.STORE_ROOM_ERROR](state, { error }) {
    state.roomStore = null
    state.roomStoreError = error
  },

  [types.GET_ROOMS_MESSAGES_START](state) {
    state.loadingRoomsMessages = true
    state.roomsMessages = []
    state.roomsMessagesIds = new Set()
    state.roomsMessagesPagination = defaultPagination
    state.errorRoomsMessages = null
    state.roomMessageActive = null
  },
  [types.GET_ROOMS_MESSAGES_SUCCESS](state, { data, pagination }) {
    const tmpData = [].concat(data, state.roomsMessages)
    state.loadingRoomsMessages = false
    state.roomsMessages = uniqWith(tmpData, function (arrVal, othVal) {
      return arrVal.roomId === othVal.roomId
    })
    state.roomsMessages = state.roomsMessages.map(function (room) {
      state.roomsMessagesIds.add(room.roomId)
      return room
    })
    state.roomsMessagesPagination = pagination
    state.errorRoomsMessages = null
    state.roomMessageActive = (data.active || null)
  },
  [types.GET_ROOMS_MESSAGES_ERROR](state, { error }) {
    state.loadingRoomsMessages = false
    state.roomsMessages = []
    state.roomsMessagesIds = new Set()
    state.roomsMessagesPagination = defaultPagination
    state.errorRoomsMessages = error
    state.roomMessageActive = null
  },

  [types.GET_ROOM_ACTIVE_START](state) {
    state.loadingRoomCustomerActive = true
    state.roomCustomerActive = null
    state.errorRoomCustomerActive = null
  },
  [types.GET_ROOM_ACTIVE_SUCCESS](state, { data }) {
    state.loadingRoomCustomerActive = false
    state.roomCustomerActive = data.data
    state.errorRoomCustomerActive = null
  },
  [types.GET_ROOM_ACTIVE_ERROR](state, { error }) {
    state.loadingRoomCustomerActive = false
    state.roomCustomerActive = null
    state.errorRoomCustomerActive = error
  },

  [types.SET_NOTIFY_ROOM_CHANGE_START](state) {
    state.loadingNotifyRoomChange = true
    state.notifyRoomChange = null
    state.errorNotifyRoomChange = null
  },
  [types.SET_NOTIFY_ROOM_CHANGE_SUCCESS](state, { data }) {
    state.loadingNotifyRoomChange = false
    state.notifyRoomChange = data.data
    state.errorNotifyRoomChange = null
  },
  [types.SET_NOTIFY_ROOM_CHANGE_ERROR](state, { error }) {
    state.loadingNotifyRoomChange = false
    state.notifyRoomChange = null
    state.errorNotifyRoomChange = error
  },

  [types.REGISTER_SUBSCRIPTION_CONVERSATION_START](state) {
    state.loadingRegisterSubscriptionConversation = true
    state.registerSubscriptionConversation = null
    state.errorRegisterSubscriptionConversation = null
  },
  [types.REGISTER_SUBSCRIPTION_CONVERSATION_SUCCESS](state, { data }) {
    state.loadingRegisterSubscriptionConversation = false
    state.registerSubscriptionConversation = data.data
    state.errorRegisterSubscriptionConversation = null
  },
  [types.REGISTER_SUBSCRIPTION_CONVERSATION_ERROR](state, { error }) {
    state.loadingRegisterSubscriptionConversation = false
    state.registerSubscriptionConversation = null
    state.errorRegisterSubscriptionConversation = error
  },

  [types.GET_ROOM_START](state) {
    state.loadingRoom = true
    state.room = null
    state.errorRoom = null
  },
  [types.GET_ROOM_SUCCESS](state, { data }) {
    state.loadingRoom = false
    state.room = data.data
    state.errorRoom = null
  },
  [types.GET_ROOM_ERROR](state, { error }) {
    state.loadingRoom = false
    state.room = null
    state.errorRoom = error
  },

  [types.GET_ROOM_HISTORY_START](state) {
    state.loadingRoomHistory = true
    state.roomHistory = null
    state.errorRoomHistory = null
  },
  [types.GET_ROOM_HISTORY_SUCCESS](state, { data }) {
    state.loadingRoomHistory = false
    state.roomHistory = data.data
    state.errorRoomHistory = null
  },
  [types.GET_ROOM_HISTORY_ERROR](state, { error }) {
    state.loadingRoomHistory = false
    state.roomHistory = null
    state.errorRoomHistory = error
  },
}

export const actions = {
  async getRooms({ commit }, payload) {
    try {
      commit(types.GET_ROOMS_START)
      const href = createTheParametersOfTheUrl(payload)
      const { data } = await axios.get(`/api/sale/conversations${href}`)

      commit(types.GET_ROOMS_SUCCESS, { data })
    } catch (e) {
      commit(types.GET_ROOMS_ERROR, { error: null })
    }
  },
  async getRoom({ commit }, payload) {
    try {
      commit(types.GET_ROOM_START)

      const { data } = await axios.get(`/api/sale/conversations/${payload}`)

      commit(types.GET_ROOM_SUCCESS, { data })
    } catch (e) {
      commit(types.GET_ROOM_ERROR, { error: null })
    }
  },
  async getRoomsMessages({ commit }, payload) {
    try {
      const href = createTheParametersOfTheUrl(payload)
      const { data } = await axios.get(`/api/sale/messages${href}`)
      const pagination = getObjectValue(data, 'meta.pagination')
      commit(types.GET_ROOMS_MESSAGES_SUCCESS, { data: data.data, pagination })
      setLintenerRoomCreated(connect())
    } catch (e) {
      commit(types.GET_ROOMS_MESSAGES_ERROR, { error: null })
    }
  },
  async storeRoom({ commit }, createForm) {
    try {
      commit(types.STORE_ROOM_START)
      const { data } = await createForm.post('/api/sale/messages')
      commit(types.STORE_ROOM_SUCCESS, { data })
    } catch (e) {
      commit(types.STORE_ROOM_ERROR, { error: null })
    }
  },
  async getRoomActive({ commit }, sid) {
    try {
      commit(types.GET_ROOM_ACTIVE_START)
      const { data } = await axios.get(`/api/sale/precontracts/${sid}/messages`)

      commit(types.GET_ROOM_ACTIVE_SUCCESS, { data })
    } catch (e) {
      commit(types.GET_ROOM_ACTIVE_ERROR, { error: null })
    }
  },
  async getRoomHistory({ commit }, sid) {
    try {
      commit(types.GET_ROOM_HISTORY_START)

      const { data } = await axios.get(`/api/sale/precontracts/${sid}/conversations`)

      commit(types.GET_ROOM_HISTORY_SUCCESS, { data })
    } catch (e) {
      commit(types.GET_ROOM_HISTORY_ERROR, { error: null })
    }
  },
  async notifyRoomChange({ commit }, {sid, params}) {
    try {
      commit(types.SET_NOTIFY_ROOM_CHANGE_START)
      const { data } = await axios.post(`/api/sale/messages/${sid}/notify_room_change`, params)

      commit(types.SET_NOTIFY_ROOM_CHANGE_SUCCESS, { data })
    } catch (e) {
      commit(types.SET_NOTIFY_ROOM_CHANGE_ERROR, { error: null })
    }
  },
  async registerSubscriptionConversation({ commit }, {sid, params}) {
    try {
      commit(types.REGISTER_SUBSCRIPTION_CONVERSATION_START)
      const { data } = await axios.post(`/api/sale/messages/${sid}/register_subscription_conversation`, params)

      commit(types.REGISTER_SUBSCRIPTION_CONVERSATION_SUCCESS, { data })
    } catch (e) {
      commit(types.REGISTER_SUBSCRIPTION_CONVERSATION_ERROR, { error: null })
    }
  },
}

// getters
export const getters = {
  loadingRooms: state => state.loading,
  rooms: state => state.rooms,
  roomActive: state => state.roomActive,
  errorRooms: state => state.error,
  roomStore: state => state.roomStore,
  roomStoreError: state => state.roomStoreError,
  loadingRoomsActiveMessages: state => state.loadingRoomsMessages,
  roomsActiveMessages: state => state.roomsMessages,
  roomsActivePagination: state => state.roomsMessagesPagination,
  errorRoomsActiveMessages: state => state.errorRoomsMessages,
  roomMessageActive: state => state.roomMessageActive,
  loadingRoomCustomerActive: state => state.loadingRoomCustomerActive,
  roomCustomerActive: state => state.roomCustomerActive,
  errorRoomCustomerActive: state => state.errorRoomCustomerActive,
  loadingRegisterSubscriptionConversation: state => state.loadingRegisterSubscriptionConversation,
  registerSubscriptionConversation: state => state.registerSubscriptionConversation,
  errorRegisterSubscriptionConversation: state => state.errorRegisterSubscriptionConversation,
  loadingCurrentRoom: state => state.loadingRoom,
  currentRoom: state => state.room,
  errorCurrentRoom: state => state.errorRoom,
  loadingRoomHistory: state => state.loadingRoomHistory,
  roomHistory: state => state.roomHistory,
  errorRoomHistory: state => state.errorRoomHistory,
  loadingNotifyRoomChange: state => state.loadingNotifyRoomChange,
}
